module.exports = __webpack_public_path__ + "assets/img/on1-53653f39.png";